<form [formGroup]="passwordResetForm" (ngSubmit)="changePassword()">
	<div class="row">
		<div class="col-md-12 text-center mb-2">
			<h2>Set Password</h2>
		</div>
		<div class="col-md-12">
			<div class="form-group">
				<div class="input">
					<input type="password" id="password" placeholder="Password" class="input form-control margin-bottom-15" formControlName="password" required />
				</div>
			</div>
			<div *ngIf="formErrors.password" class="alert alert-danger" role="alert">
				{{ formErrors.password }}
			</div>
		</div>
		<div class="col-md-12">
			<button type="submit" class="btn btn-primary btn-block" [disabled]="!passwordResetForm.valid">Set Password</button>
		</div>
		<div *ngIf="message.message != ''">
			<div class="col-md-12">
				<span [ngClass]="message.type === 'success' ? 'm--font-success' : 'm--font-danger'">
					{{ message.message }}
				</span>
			</div>
		</div>
	</div>
</form>
